import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import router from './config/router'
import store from './store'; // 引入store
import ElementUI from 'element-ui';
import method from '@/config/api'
import request from '@/config/index'
import 'element-ui/lib/theme-chalk/index.css';
import './style.css'
import './mixin.css'

/* rem */
import '@/utils/rem.js';

Vue.use(Router)
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$method = method;
Vue.prototype.$postRequest = request.post;
Vue.prototype.$getRequest = request.get;
Vue.prototype.$imgurl = request.baseURL;

import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);
import messageToast from '../components/messageToast.vue'; 
Vue.component('messageToast', messageToast);
import share from '../components/share.vue'; 
Vue.component('share', share);
import vipimg from '../components/vipimg.vue'; 
Vue.component('vipimg', vipimg);
// 发布者订阅 公共bus
const Bus = new Vue();
export default Bus;

document.title = '方案库'

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
